import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

import ListView from '../Common/ListView.react';
import ListItem from './MyModuleListItem.react';
import LinearProgress from 'material-ui/LinearProgress';
import FlatButton from 'material-ui/FlatButton';

import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import SkillIcon from 'material-ui/svg-icons/social/public';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import ActivityIcon from 'material-ui/svg-icons/action/timeline';
import ComplianceIcon from 'material-ui/svg-icons/action/done-all';
import ModuleIcon from 'material-ui/svg-icons/action/view-module';

import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleStore from '../../stores/ModuleStore';
import ModuleTypeStore from '../../stores/ModuleTypeStore';

import buildContextMenu from '../Common/BuildContextMenu';
import { capitalise } from '../../utils/StringUtils';

class MyModuleList extends Component {

    constructor(props, context) {
        super(props);

        this.state = {
            title: 'My modules',
            modules: [],
            actions: buildContextMenu(this.getActions(), context.auth),
            types: [],
            page: 0,
            limit: 50,
            searchPage: 0,
            searchMode: false,
            searchText: null,
            isLoading:  true,
            fetchedAll: false,
            showButton: false
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.onTypesChange = this.onTypesChange.bind(this);
        this.sort = this.sort.bind(this);
        this.filter = this.filter.bind(this);
        this.throttleSearch = this.throttleSearch.bind(this);
        this.toggleSearchMode = this.toggleSearchMode.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        this.listeners = [
            ModuleStore.addListener(this.onChange),
            ModuleTypeStore.addListener(this.onTypesChange)
        ];
        let params = {limit: this.state.limit};
        if (this.props.completed !== undefined) {
            params.completed = this.props.completed;
        }
        ModuleActions.getMy(this.props.type, params);
        ModuleActions.getTypeOptions();

        this.setState({actions: buildContextMenu(this.getActions(), this.context.auth)});

        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());

        window.removeEventListener('scroll', this.handleScroll);
    }

    getActions() {
        return [
            {
                link: '/dashboard/mytraining',
                icon: <SchoolIcon />,
                label: 'My training',
            },
            {
                link: '/dashboard/mytraining/compliance',
                icon: <ComplianceIcon />,
                label: 'My compliance',
            },
            {
                link: '/dashboard/mytraining/skills',
                icon: <SkillIcon />,
                label: 'My skills',
            },
            {
                link: '/dashboard/mytraining/courses',
                icon: <SchoolIcon />,
                label: 'My courses',
            },
            {
                link: '/dashboard/mytraining/modules',
                icon: <ModuleIcon />,
                label: 'My modules',
            },
            {
                link: '/dashboard/mytraining/resources',
                icon: <LibraryIcon />,
                label: 'My resources',
            },
            {
                link: '/dashboard/mytraining/activities',
                icon: <ActivityIcon />,
                label: 'My Activities',
            },
            {
                type:'divider'
            },
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            },
        ];
    }

    render() {

        return (
            <div ref="myModules">
                <ListView
                    title={`${this.state.title}${!!this.props.completed ? ' (completed)' : ''}`}
                    sortOptions={this.props.sortOptions}
                    sortAction={this.sort}
                    actions={this.state.actions}
                    items={this.state.modules}
                    itemDecorator={ListItem}
                    filterAction={this.filter}
                    filterOptions={[
                        { label: 'Show all', value: null },
                        ...this.state.types.map(({ name }) => ({ label: capitalise(name), value: name }))
                    ]}
                    searchAction={this.throttleSearch}
                    toggleSearchMode={this.toggleSearchMode}
                />
                {this.state.isLoading && (
                    <LinearProgress mode="indeterminate" />
                )}
                {this.state.showButton && (
                    <FlatButton
                        label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                        icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                        onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                        disabled={this.state.isLoading}
                        fullWidth
                    />
                )}
            </div>
        );
    }

    onChange() {
        let modules = ModuleStore.getMy(this.props.type);
        if (this.props.completed !== undefined) {
            if (this.props.completed) {
                modules = modules.filter(({enrolmentStatus}) => enrolmentStatus === 'completed');
            } else {
                modules = modules.filter(({enrolmentStatus}) => enrolmentStatus !== 'completed');
            }
        }

        if (!!modules) {
            if (modules.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                this.setState({modules, isLoading: false});
            } else {
                const mapped = modules.map(this.state.sortMapCriteria);
                mapped.sort(this.state.sortCriteria);
                const sortedModules = mapped.map((el) => modules[el.index]);
                this.setState({modules: sortedModules, isLoading: false});
            }
        }
        if (ModuleStore.fetchedAll()) {
            this.setState({fetchedAll: true});
        }
    }

    onTypesChange() {
        const types = ModuleTypeStore.getAll();
        if (!!types) {
            this.setState({types});
        }
    }

    sort(options) {
        let sortCriteria, sortMapCriteria;
        switch (options.sort) {
            case 'name':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.name});
                break;
            case 'code':
                sortCriteria = (a, b) => !a.value ? 1 : a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.code});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[this.state.sort]});
        }
        this.setState({sort: options.sort, sortCriteria, sortMapCriteria});
        ModuleActions.getMy(this.props.type , {sort: options.sort});
    }

    filter({filter}) {
        let link = !filter ? '/dashboard/mytraining/modules' : `/dashboard/mytraining/modules/${filter}`;
        if (this.props.completed !== undefined) {
            link = `${link}?completed=${this.props.completed}`;
        }
        this.setState({
            title: !!filter ? capitalise(filter) : 'My modules',
            isLoading: true,
            modules: [],
            showButton: false
        });
        ModuleActions.getMy(filter);
        browserHistory.replace(link);
    }

    throttleSearch(searchText) {
        this.timeout && clearTimeout(this.timeout);
        if (!!searchText && searchText.length > 2) {
            this.timeout = setTimeout(() => { ModuleActions.searchMy(searchText, {limit: this.state.limit, type: this.props.type || null}); }, 500);

            if (searchText !== this.state.searchText) {
                this.setState({fetchedAll: false, showButton: false});
            }
            this.setState({searchText, searchPage: 0});
        }
    }

    toggleSearchMode(searchMode) {
        if (!searchMode) {
            this.setState({searchText: null});
        }
        this.setState({searchMode, fetchedAll: false, showButton: false});
    }

    loadNextPage() {
        if (this.state.isLoading) { return; } //guard

        const page = !this.state.searchMode ? (this.state.page + 1) : (this.state.searchPage + 1);
        if (!this.state.searchMode) {
            ModuleActions.getMy(this.props.type, {page, limit: this.state.limit, completed: this.props.completed !== undefined ? this.props.completed : null});
            this.setState({page, isLoading: true});
        } else if (!!this.state.searchText) {
            ModuleActions.searchMy(this.state.searchText, {page, limit: this.state.limit, type: this.props.type});
            this.setState({searchPage: page, isLoading: true});
        }
    }

    handleScroll() {
        if (!this.state.showButton && window.scrollY) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) === this.refs.myModules.clientHeight) {
            this.loadNextPage();
        }
    }
}

MyModuleList.contextTypes = {
    auth: PropTypes.object.isRequired
};

MyModuleList.defaultProps = {
    sortOptions: [
        {label: "Title", value: 'name'},
        {label: "Code", value: 'code'},
        {label: "Started", value: 'enrolmentDate'}
    ]
};

export default MyModuleList;
